/**
 * Collection filters: a drawer, at every width.
 *
 * It used to be two things - a sheet below 1000px and a permanently visible
 * sidebar above it - and this file switched between them at the breakpoint.
 * The sidebar is gone: a 226px column holding two filter groups left most of a
 * column empty down the page, so the stylesheet now makes .cfil a right-hand
 * drawer at every width, opened by FILTER like the menu and the cart.
 *
 * The breakpoint branch outlived that change and actively fought it - above
 * 1000px it stripped `is-on`, `role` and `aria-modal` and left the panel
 * parked inside the collection grid, so the desktop drawer would sometimes
 * open and immediately un-open itself. One behaviour now, which is what the
 * CSS already assumes.
 *
 * Two things still have to happen in JavaScript rather than in markup:
 *
 *   - The panel must sit at the end of <body>. It is position: fixed, and the
 *     scroll-reveal layer puts a transform on an ancestor, which would become
 *     its containing block and pin it to the section instead of the viewport.
 *   - A closed drawer must be `inert`, so its filters are out of the tab order
 *     and hidden from screen readers until it is opened. calmy-core.js clears
 *     and restores that on open and close; this only sets the initial state.
 */
(function () {
  "use strict";

  var el = document.querySelector("[data-calmy-filters]");
  if (!el) return;

  if (el.parentElement !== document.body) document.body.appendChild(el);

  el.setAttribute("role", "dialog");
  el.setAttribute("aria-modal", "true");
  if (!el.classList.contains("is-on")) el.setAttribute("inert", "");
})();
